import {createSelector} from 'reselect';
import {detectCollisions} from "../../helpers/collisionDetector";
import { getLidOpeningErrorSets, getIntermediateCeilingOpeningErrorSets } from "../../validation/vault/messages/manholeArrangement";
import {getManholeOpeningDirectionErrorIds} from "../../validation/vault/messages/manholeOpeningDirection";
import {getManholeCountErrorIds} from "../../validation/vault/messages/manholeCount";

export const makeSelectCollidingIdsForSide = () =>
    createSelector(
        [(s, side: number) => s.plan.vault?.walls[side]?.sleeves],  // input
        detectCollisions,
    );

export const makeSelectLidElementErrorIds = () =>
    createSelector(
        [(s) => s.plan],
        (plan) => {
            const {manholeIds, circIds, rectIds} = getLidOpeningErrorSets(plan as any)
            const openingDirectionErrorIds = getManholeOpeningDirectionErrorIds(plan as any)
            const manholeCountErrorIds = getManholeCountErrorIds(plan as any)

            return [
                ...manholeIds,
                ...circIds,
                ...rectIds,
                ...openingDirectionErrorIds,
                ...manholeCountErrorIds,
            ]
        }
    );

export const makeSelectIntermediateOpeningErrorSets = () =>
    createSelector(
        [(s) => s.plan],
        (plan) => getIntermediateCeilingOpeningErrorSets(plan as any)
    );
